<div class="chart-container">
  @if (data.loading) {
    <p-skeleton width="100%"
                height="100%"
    />
  } @else {
    <p-chart type="line"
             [data]="data"
             [options]="chartOptions"
             class="chart">
    </p-chart>

    <!--<div class="legend">
      <p class="legend-text blue">
        <span class="material-symbols-rounded">circle</span>

        {{'common.table.key.devices_total' | translateSafe}}
      </p>

      <p class="legend-text red">
        <span class="material-symbols-rounded">circle</span>
        {{'common.table.key.devices_total' | translateSafe}}

      </p>
    </div>-->
  }
</div>
